import React, { useRef, useState, useEffect } from "react";
import { Avatar, Badge, Button, Card, Checkbox, Dialog, FormControlLabel, Grid, Tab, Tabs, Tooltip } from "@mui/material";
import TCAccordion from "components/TopCourtComponents/TCAccordion";
import { bracketAssign, generateTournament, getApplicantVerification, getTournamentBracket, getTournamentCategoryLevel, getTournamentParticipant, getTournamentParticipantPoolBracket, getTournamentPool, poolAssign, updateRegistrationStatus } from "services/tournamentServices";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import { IconCheck, IconHourglass, IconPencil, IconX } from "@tabler/icons";
import { updateVerificationPhoto, updateVerificationStatus } from "services/dashboardServices";
import { handleUpload } from "helper/S3";
import { TCInput } from "components/TopCourtComponents/Input/TopCourtInput";
import { color } from "constant/constant";
import { getUrlCourtCode } from "helper/Court";
import ImageCropper from "components/CropImage";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";
import BlockUi from "react-block-ui";
import { Link } from "react-router-dom";
import DynamicPoolsTable from "./component/poolTable";
import SingleElimBracketAssignById from "./component/poolBracket";
import moment from "moment";

function TournamentParticipant({ tournamentInfo, tabList, tournamentId, additionalInfoTitle, reloadTournament }) {
  const [currentTab, setCurrentTab] = useState(0);
  const [tabWidth, setTabWidth] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && tabList.length > 0) {
      setTabWidth(ref.current.offsetWidth / tabList.length);
      for (let i = 0; i < tabList.length; i ++) {
        if (tabList[i].data?.pending > 0) {
            setCurrentTab(i); break;
        }
      }
    }
  }, [tabList]);

  useEffect(() => { }, [tabWidth, currentTab])

  return (
    <Grid key={tabWidth} style={{
      minWidth: '100%'
    }} ref={ref} overflow={'hidden'}>
      <Tabs
        value={currentTab}
        orientation="horizontal"
        variant="scrollable"
        onChange={(e, newValue) => setCurrentTab(newValue)}
        // sx={{ borderRight: 1, borderColor: "divider" }}
      >
        {tabList.map(({ key, label, data }) => (
          <Tab
            key={key}
            label={<TCLabel style={{
              fontSize: 13
            }}>{label}{` (${data.applicant})`}{(data.pending > 0 || data.waitingList > 0) && (
                <span
                    style={{
                        position: 'absolute',
                        marginLeft: "6px",
                        minWidth: "18px",
                        height: "18px",
                        right: 0,
                        top: '20%',
                        backgroundColor: "red",
                        borderRadius: "50%",
                        border: "2px solid white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontSize: "10px",
                        fontWeight: "bold",
                        lineHeight: 1,
                        padding: "0 4px", // allows for double-digit numbers
                    }}
                    >
                    {data.pending + data.waitingList}
                </span>
            )}</TCLabel>}
            sx={{
              // minWidth: tabWidth || "auto",
              width: tabWidth || 100,
              maxWidth: 150 || "auto",
              backgroundColor: currentTab === key ? "white" : "",
              borderTopLeftRadius: 1,
              borderTopRightRadius: 1,
              padding: 2
            }}
            onClick={() => setCurrentTab(key)}
          />
        ))}
      </Tabs>
      <LevelList tournamentInfo={tournamentInfo} key={currentTab} tournamentId={tournamentId} categoryId={tabList[currentTab]?.value} reloadTournament={reloadTournament} additionalInfoTitle={additionalInfoTitle}/>
    </Grid>
  );
}

function LevelList ({
    tournamentInfo,
    tournamentId,
    categoryId,
    reloadTournament,
    additionalInfoTitle
}) {
  const [ level, setLevel ] = useState([])
  const [ loading, setLoading ] = useState(false)

  useEffect(() => {
    loadLevel()
  }, [])

  const loadLevel = async () => {
    setLoading(true)
    let { data, error } = await getTournamentCategoryLevel({
      id: tournamentId, 
      categoryId: categoryId
    })
    if (data) { setLevel(data) }
    setLoading(false)
  }

  return (
    <Grid>
      {level.map(v => {
        return (
          <Grid p={2} pb={0}>
            {
                !loading &&
                <LevelAccordion v={v} 
                    tournamentInfo={tournamentInfo}
                    defaultExpand={level.length == 1 || v.pending > 0}
                    tournamentId={tournamentId} categoryId={categoryId} reloadTournament={reloadTournament}
                    additionalInfoTitle={additionalInfoTitle} tournamentDetailCategoryId={v._id}
                />
            }
            {
                loading && <BlockUi tag="div" blocking={loading}/>
            }
            {/* <TCLabel bold>{v.name}</TCLabel>
            <ParticipantList tournamentId={tournamentId} categoryId={categoryId} levelId={v._id}/> */}
          </Grid>
        )
      })}
    </Grid>
  )
}

function LevelAccordion ({
  v, tournamentInfo, tournamentId, categoryId, reloadTournament, additionalInfoTitle, defaultExpand, tournamentDetailCategoryId
}) {

    const [ expand, setExpand ] = useState(defaultExpand)
    const [ tabList, setTabList ] = useState([
        {
            key: 0,
            label: "Approved",
            totalData: v.approved
        }, {
            key: 1,
            label: "Pending",
            totalData: v.pending
        }, {
            key: 2,
            label: "Waiting List",
            totalData: v.waitingList
        }
    ])


    return (
        <>
        <Grid container alignItems={"center"}
            justifyContent={"space-between"} style={{
            cursor: 'pointer'
            }}
        >
            <Grid item xs>
                <Grid xs={12} onClick={() => { setExpand(!expand) }}><TCLabel>{v.name}</TCLabel></Grid>
                {
                    !expand &&
                    <Grid onClick={() => { setExpand(!expand) }}>
                        <Tabs
                            orientation="horizontal"
                            variant="scrollable"
                            sx={{ padding: 0 }}
                            // sx={{ borderRight: 1, borderColor: "divider" }}
                        >
                            {tabList.map(({ key, label, totalData }) => (
                                <Tab
                                    key={key}
                                    label={<TCLabel style={{fontSize: 13}}>{`${label} (${totalData || 0})`}</TCLabel>}
                                    sx={{
                                        borderTopLeftRadius: 1,
                                        borderTopRightRadius: 1,
                                        padding: 0
                                    }}
                                />
                                ))}
                        </Tabs>
                    </Grid>
                }
                {
                    expand &&
                    <Grid sx={{ minHeight: 40 }}></Grid>
                }
            </Grid>
            <Grid item xs onClick={() => { setExpand(!expand) }} sx={{ zIndex: 99, textAlign: 'right' }}>
                {expand ? <ArrowDropUp/> :<ArrowDropDown />}
            </Grid>
        </Grid>
        <AnimatePresence initial={true}>
            {expand && (
            <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
            >
                <div style={{
                    marginTop: -40
                }}>
                    <ParticipantList tournamentInfo={tournamentInfo} tournamentDetailCategoryId={tournamentDetailCategoryId} tournamentId={tournamentId} categoryId={categoryId} levelId={v.levelId} reloadTournament={reloadTournament} additionalInfoTitle={additionalInfoTitle}/>
                </div>
            </motion.div>
            )}
        </AnimatePresence>
        </>
    )
}

// add check information 
// Jika tidak ada yg notif merah, maka bukanya lgsg ke list pemain yg sudah di approve. Jika kedepannya ada lebih dari 1 level:
// 1. Jika tidak ada notif, maka semua close. User yg pilih mau jabarkan yg mana
// 2. ⁠Jika ada notif, maka lgsg buka yg ada notif cth: ada 2 level yaitu beginner & advanced. Yg ada notif masuk itu yg advanced, maka:
// -beginner (closed)
// -advanced (auto jabarkan & buka di halaman pendingnya)

function ParticipantList ({
  tournamentInfo, tournamentId, categoryId, levelId, reloadTournament, additionalInfoTitle, tournamentDetailCategoryId
}) {

  const [ loading, setLoading ] = useState(false)
  const [ participant, setParticipant ] = useState({
    applicantList: [],
    pendingList: [],
    waitingList: []
  })
  const [ tabList, setTabList ] = useState([
    {
        key: 0,
        label: "Approved",
        totalData: 0
    }, {
        key: 1,
        label: "Pending",
        totalData: 0
    }, {
        key: 2,
        label: "Waiting List",
        totalData: 0
    }
])

  const [ currentTab, setCurrentTab ] = useState(0)
  const [ pools, setPools ] = useState([])
  const [ brackets, setBrackets ] = useState([])
  const [ optionsParticipant, setOptionsParticipant ] = useState([])
  const [ selectedParticipants, setSelectedParticipants ] = useState([])

  useEffect(() => {
    loadParticipant()
    loadParticipants()
  }, [])

  useEffect(() => {
    if (optionsParticipant.length > 0) {
        loadPools()
        loadBracket()
    }
  }, [optionsParticipant])

  const loadParticipant = async () => {
    setLoading(true)
    let { data, error } = await getTournamentParticipant({
      id: tournamentId,
      categoryId, levelId
    })
    console.log('here participant data', data)
    if (data) { 
        setParticipant(data) 
        if (data.pendingList.length > 0) { setCurrentTab(1) }
        setTabList(JSON.parse(JSON.stringify([
            {
                key: 0,
                label: "Approved",
                totalData: data.applicantList.length
            }, {
                key: 1,
                label: "Pending",
                totalData: data.pendingList.length
            }, {
                key: 2,
                label: "Waiting List",
                totalData: data.waitingList.length
            }
        ])))
    }
    setLoading(false)
  }

    // const pools = [
    //     { key: "A", label: "Pool A", seeds: 4 },
    //     { key: "B", label: "Pool B", seeds: 4 },
    //     { key: "C", label: "Pool C", seeds: 2 }, // different size OK
    // ];

    // const optionsParticipant = participant.applicantList.map(v => {
    //     return { label: v.pairs.map(vi => {return `${vi.verifyId.idName} `}), value: v._id, data: v }
    // })

    // load pool seeds
    // set player in pool

    console.log('here tournamentInfo', tournamentInfo.categoriesInfo.find(v => v.id == categoryId))

    const loadParticipants = async (

    ) => {
        let { data, error } = await getTournamentParticipantPoolBracket({
            tournamentId,
            tournamentDetailCategoryId: categoryId,
            levelId
        })
        if (data) {
            console.log('here data', data)
            let newPools = data.map(v => {
                return { label: v.userIds.map(vi => {return `${vi.verifyId.idName} `}), value: v._id, data: v }
            })
            setOptionsParticipant(newPools)
        }
    }

    const loadPools = async (
        
    ) => {
        let { data, error } = await getTournamentPool({
            tournamentId,
            tournamentDetailCategoryId: categoryId,
            levelId
        })
        if (data) {
            console.log('here data', data)
            let newPools = data.pools.map(v => {
                return {
                    key: v._id,
                    label: v.name,
                    seeds: v.seeds,
                    isWrap: v.isWrap,
                    stageId: v.stageId,
                    tournamentMatchList: v.tournamentMatchList
                }
            })
            setSelectedParticipants((prev) => [
                ...prev,
                ...data.participants
            ])
            console.log('here newPools', newPools)
            setPools(newPools)
        }
    }

    const loadBracket = async (

    ) => {
        let { data, error } = await getTournamentBracket({
            tournamentId,
            tournamentDetailCategoryId: categoryId,
            levelId
        })
        if (data) {
            console.log('here data', data)
            if (data.seeds && data.seeds.length > 0) {
                let newBrackets = data.seeds.map(v => {
                    return {
                        _id: v._id,
                        seedNumber: v.number,
                        participants: v.participants,
                        tournamentMatchList: data.tournamentMatchList
                    }
                });
                console.log('here brackets', data)
                setSelectedParticipants((prev) => [
                    ...prev,
                    ...data.participants
                ])
                setBrackets(newBrackets)
            }
        }
    }

    const assignParticipantinPool = async (
        {poolSeedId, participantId}
    ) => {
        let { data, error } = await poolAssign({
            poolSeedId, participantId
        })
        if (!participantId) { setSelectedParticipants([]) }
        if (data) { loadPools() }
    }

    const assignParticipantinBracket = async (
        {bracketSeedId, participantId}
    ) => {
        let { data, error } = await bracketAssign({
            bracketSeedId, participantId
        })
        if (!participantId) { setSelectedParticipants([]) }
        if (data) { loadBracket() }
    }

    const startTournament = async () => {
        let { data, error } = await generateTournament({
            tournamentId, tournamentDetailCategoryId
        })
        if (error) { alert(error) }
        if (data) { window.location.reload() }
    }

    console.log('here tournamentDetailCategoryId', pools, tournamentDetailCategoryId)
    
    function isTotalPlayernPoolnWinnerChanged() {
        let oldCat = tournamentInfo.listCategoriesInfo.find(v => v.tournamentCategoryId._id == categoryId);
        let newCat = tournamentInfo.categoriesInfo.find(v => v.id == categoryId);

        if (oldCat.totalPlayer == newCat.totalPlayer && 
            oldCat.numberOfPool == newCat.numberOfPool && 
            oldCat.winnersPerPool == newCat.winnersPerPool
        ) {
            return false;
        }
        return true;
    }

    return (
        <Grid>
        <BlockUi tag="div" blocking={loading}/>
        {
            !loading &&
            <>
                <Tabs
                    value={currentTab}
                    orientation="horizontal"
                    variant="scrollable"
                    onChange={(e, newValue) => setCurrentTab(newValue)}
                    sx={{ padding: 0 }}
                >
                    {tabList.map(({ key, label, totalData }) => (
                        <Tab
                            key={key}
                            label={<TCLabel style={{fontSize: 13}}>{`${label} (${totalData || 0})`}</TCLabel>}
                            sx={{
                                backgroundColor: currentTab === key ? "white" : "",
                                borderTopLeftRadius: 1,
                                borderTopRightRadius: 1,
                                padding: 0
                            }}
                            onClick={() => setCurrentTab(key)}
                        />
                        ))}
                </Tabs>
                {
                    (currentTab == 0) &&
                    <Grid mt={1}>
                        <Button variant='contained' color={"primary"} style={{ marginBottom: 8 }}
                            onClick={() => { 
                                startTournament()
                            }}
                            disabled={
                                isTotalPlayernPoolnWinnerChanged() || 
                                ((
                                    tournamentInfo.categoriesInfo.find(v => v.id == categoryId).totalPlayer != participant.applicantList.length || 
                                    tournamentInfo.registrationDeadline > moment(new Date()).format('YYYY-MM-DD') || 
                                    (pools && pools.length > 0 && pools.find(v => v.stageId?.tournamentDetailCategoryId.toString() == tournamentDetailCategoryId.toString())?.tournamentMatchList > 0) || 
                                    (brackets && brackets.length > 0 && brackets[0].tournamentMatchList > 0)
                                ) && tournamentInfo.categoriesInfo.find(v => v.id == categoryId).matchStart > 0)
                            }
                        >Generate Tournament</Button>
                        <DynamicPoolsTable
                            participants={optionsParticipant}
                            pools={pools}
                            onAssign={(key, idx, opt) => {
                                // Persist: assign player opt?.value to pool=key, seed=(idx+1)
                                console.log("assign", key, idx + 1, opt?.value);
                                if (!key.option) {assignParticipantinPool({poolSeedId: key.seedId, participantId: null}); return; }
                                assignParticipantinPool({poolSeedId: key.seedId, participantId: key.option.data._id})
                            }}
                            disabled={((pools && pools.length > 0) ? pools.find(v => v.stageId?.tournamentDetailCategoryId.toString() == tournamentDetailCategoryId.toString())?.tournamentMatchList > 0 : false)}
                        />
                        {
                            brackets.length > 0 &&
                            <SingleElimBracketAssignById
                                participants={optionsParticipant}
                                seedSlots={brackets}
                                size={brackets.length}
                                onAssign={({ slotId, option }) => {
                                    console.log("assign bracket", slotId, option );
                                    if (!option) {assignParticipantinBracket({bracketSeedId: slotId, participantId: null}); return; }
                                    assignParticipantinBracket({bracketSeedId: slotId, participantId: option.value})
                                }}
                                // disabled={pools && pools.length > 0 ? pools.some(v => !v.isWrap) ? true : false : false}
                                disabled={pools && pools.length > 0 ? true : false}
                            />
                        }
                        <Grid p={2}/>
                        {
                            participant.applicantList.map(v => {
                                console.log('here check disabled', selectedParticipants, v)
                                return <ParticipantCard value={v} reload={() => {}} status={"approve"} isFull={participant.isFull}
                                    loadParticipant={(e) => { loadParticipant() }} 
                                    additionalInfoTitle={additionalInfoTitle}
                                    disabled={selectedParticipants.some(value => value.toString() == v._id.toString())}
                                    reloadTournament={(e) => { reloadTournament() }}
                                />
                            })
                        }
                    </Grid>
                }
                {
                    (currentTab == 1) &&
                    <Grid mt={1}>
                        {/* <TCLabel fontSize={12} bold>Pending ({participant.pendingList.length})</TCLabel> */}
                        {
                        participant.pendingList.map(v => {
                            return <ParticipantCard value={v} reload={() => {}} status={"pending"} isFull={participant.isFull}
                                additionalInfoTitle={additionalInfoTitle}
                                loadParticipant={(e) => { loadParticipant() }} reloadTournament={(e) => { reloadTournament() }}
                            />
                        })
                        }
                    </Grid>
                }
                {
                    (currentTab == 2) &&
                    <Grid mt={1}>
                        {/* <TCLabel fontSize={12} bold>Waiting List ({participant.waitingList.length})</TCLabel> */}
                        {
                        participant.waitingList.map(v => {
                            return <ParticipantCard value={v} reload={() => {}} status={"waiting_list"} isFull={participant.isFull}
                                additionalInfoTitle={additionalInfoTitle}
                                loadParticipant={(e) => { loadParticipant() }} reloadTournament={(e) => { reloadTournament() }}
                            />
                        })
                        }
                    </Grid>
                }
            </>
        }
        </Grid>
    )
}

function ParticipantCard ({
  loadParticipant,
  additionalInfoTitle,
  reloadTournament,
  status,
  value, 
  disabled,
  isFull
}) {

    console.log('here check disabled', disabled)

  const [unverified, setUnverified ] = useState(false)
  const [pendingApplicant, setPendingApplicant ] = useState(false)
  const [openDialog, setOpenDialog ] = useState({
      open: false,
      data: null
  })
  const [ loading , setLoading ] = useState(false)
  const [ openVerify, setOpenVerify ] = useState(false)

  useEffect(() => {
      for (let i = 0; i < value.pairs.length; i ++) {
          if(!value.pairs[i].verifyId) { setUnverified(true); }
          if (value.pairs[i].pendingApplicant > 0) { setPendingApplicant(true); }
      }
  }, [value])

  const updateApplicationStatus = async ({
        _id, status
    }) => {
      console.log('here _id, status', _id, status)
      let { data, error } = await updateRegistrationStatus({
          _id, status
      })
      setLoading(false)
      setOpenDialog({
        open: false,
        data: null,
        type: ''
      })
      loadParticipant()
      reloadTournament()
  }

  return (
    <Grid container xs={12} p={1} mb={1} sx={{
          border: '1px solid rgb(133, 133, 133)', borderRadius: 2
      }}>
          {
              value.pairs.map((v, idx) => {
                  return (
                      <Grid xs={12} mb={1}>
                          <Grid item container xs={12} alignItems={"center"}>
                          <Grid item xs={2} sm={1} mr={1}>
                              <Avatar src={v.verifyId ? `//wsrv.nl/?url=${v.verifyId.idPhoto}&filename=${v.verifyId.idName}`: ''}/>
                              {/* <Avatar src={v.verifyId ? v.verifyId.idPhoto : ''}/> */}
                          </Grid>
                          <Grid item container xs={8} sm={3}>
                              <Grid item xs={12}>
                                  <TCLabel><Link className='span-link' to={`/${getUrlCourtCode()}/users/detail/${v.userId}`}>{v.verifyId ? v.verifyId.idName : v.name}</Link></TCLabel>
                              </Grid>
                              <Grid item>
                                  <TCLabel>{v.gender}</TCLabel>
                              </Grid>
                          </Grid>
                          {
                              (idx == 0 && window.innerWidth >= 600) &&
                              <Grid mt={1} item container xs sm textAlign={"right"} justifyContent={"flex-end"}>
                                  <Grid container xs={12} spacing={0.5} justifyContent={"flex-end"}>
                                      {
                                          ((!v.verifyId || unverified) && pendingApplicant) &&
                                          <Grid item>
                                              <Button variant='contained'
                                                  style={{ fontSize: 10 }}
                                                  onClick={() => {
                                                      setOpenVerify(!openVerify)
                                                  }}
                                              >Verify</Button>
                                          </Grid>
                                      }
                                      <Grid item>
                                          <Button variant='contained' style={{
                                              backgroundColor: (loading || disabled) ? '' : '#E35480'
                                          }}  
                                          disabled={loading || disabled}
                                          onClick={() => {
                                              setOpenDialog({
                                                  open: true,
                                                  type: 'reject',
                                                  data: value
                                              })
                                          }}><IconX size={15}/></Button> 
                                      </Grid>
                                      {
                                          (status !== 'waiting_list') &&
                                          <Grid item>
                                              <Button variant="contained" 
                                              disabled={loading || disabled}
                                              sx={{
                                                  backgroundColor: '#FFA500'
                                              }}
                                              onClick={() => {
                                                  updateApplicationStatus({
                                                      _id: value._id,
                                                      status: 'waiting_list'
                                                  })
                                              }}><IconHourglass size={15}/></Button> 
                                          </Grid>
                                      }
                                      {
                                          (status !== "approve") &&
                                          <Grid item>
                                              {
                                                  isFull ?
                                                  <Tooltip title={"Full"}>
                                                      <span>
                                                          <Button variant="contained" 
                                                              sx={{
                                                                  backgroundColor: '#0198E1'
                                                              }}
                                                              disabled={(!v.verifyId || unverified) || loading || isFull}
                                                              onClick={() => {
                                                                  if (!v.verifyId || unverified) { return; }
                                                                  setOpenDialog({
                                                                      open: true,
                                                                      type: 'approve',
                                                                      data: v
                                                                  })
                                                              }}><IconCheck size={15}/></Button> 
                                                      </span>
                                                  </Tooltip>
                                                  :
                                                  <Button variant="contained" 
                                                      sx={{
                                                          backgroundColor: '#0198E1'
                                                      }}
                                                      disabled={(!v.verifyId || unverified) || loading || isFull}
                                                      onClick={() => {
                                                          if (!v.verifyId || unverified) { return; }
                                                          setOpenDialog({
                                                              open: true,
                                                              type: 'approve',
                                                              data: value
                                                          })
                                                      }}><IconCheck size={15}/></Button> 
                                              }
                                          </Grid>   
                                      }
                                  </Grid>
                              </Grid>
                          }
                          <Grid item xs={12}>
                              <TCLabel>{additionalInfoTitle}</TCLabel>
                          </Grid>
                      </Grid>
                      {
                          v.description &&
                          <Grid item container xs={12} sx={{
                              width: '100%'
                          }}>
                              <Grid item>
                                  <TCLabel>
                                      {/* <div dangerouslySetInnerHTML={{__html: data.description}}/> */}
                                      <div>
                                          <div style={{width: '100%', wordBreak: 'break-word',
                                                  overflowWrap: 'anywhere',
                                                  whiteSpace: 'pre-line'}}>{v.description}</div>
                                          {/* {(data.description.length > 200 && (!showMore && !data.disableJoin)) ?
                                              <div style={{width: '100%', wordBreak: 'break-word',
                                                  overflowWrap: 'anywhere',
                                                  whiteSpace: 'pre-line'}} dangerouslySetInnerHTML={{__html: vi.description.slice(0, 200)}}/>
                                              :
                                              <div style={{width: '100%', wordBreak: 'break-word',
                                                  overflowWrap: 'anywhere',
                                                  whiteSpace: 'pre-line'}} dangerouslySetInnerHTML={{__html: vi.description}}/>
                                          } */}
                                          {/* {
                                              (showMore || data.disableJoin) &&
                                              <Grid item container pt={1}>
                                                  {
                                                      data.classImages && data.classImages.map(value => {
                                                          return(<Grid item xs={6} style={{height: 'auto', width: '100%'}}
                                                              onClick={() => {
                                                                  setOpenImageDetail({
                                                                      open: true,
                                                                      image: value
                                                                  })
                                                              }}
                                                          >
                                                              <img src={value} style={{
                                                                  objectFit: 'contain'
                                                              }} width={"100%"} height={"100%"}/>
                                                          </Grid>)
                                                      })
                                                  }
                                              </Grid>
                                          } */}
                                          {/* {(data.description.length > 200) && 
                                              <Grid textAlign={"right"} onClick={() => {
                                                  setShowMore(!showMore)
                                              }}>
                                                  <TCLabel style={{marginTop: 2, fontSize: 10, fontWeight: 'bold'}}>{
                                                      !showMore ? '... Show more' : 'Show Less'
                                                  }</TCLabel>
                                              </Grid>
                                          } */}
                                      </div>
                                  </TCLabel>
                              </Grid>
                          </Grid>
                      }
                      {
                          (!v.verifyId && openVerify) &&
                          <Grid item container xs={12} ml={-1} mt={-1.5} sx={{
                              width: '100%'
                          }}>
                              <Grid xs={12}>
                                  <VerificationForm userId={v.userId} reloadAll={() => {
                                      loadParticipant()
                                  }}/>
                              </Grid>
                          </Grid>
                      }
                      {
                          (((value.pairs.length - 1) == idx) && window.innerWidth < 600) &&
                          <Grid ml={-1} mt={1} item container xs sm textAlign={"right"} justifyItems={"flex-end"}>
                              {/* <Grid item>
                                  <Button variant='contained' style={{ backgroundColor: '#E35480' }}
                                      onClick={() => { updateVerification({
                                          _id: row._id,
                                          reject: true, verify: false
                                      }) }}
                                  >Reject</Button>
                              </Grid>
                              <Grid item>
                                  <Button variant='contained'
                                      onClick={() => {
                                          updateVerification({
                                              _id: row._id,
                                              name: row.idName,
                                              gender: row.userId.gender,
                                              reject: false, verify: true
                                          })
                                      }}
                                  >Verify</Button>
                              </Grid> */}
                              <Grid container xs={12} spacing={0.5}>
                                  {
                                      (!v.verifyId || unverified) &&
                                      <Grid item>
                                          <Button variant='contained'
                                              style={{ fontSize: 10 }}
                                              onClick={() => {
                                                  setOpenVerify(!openVerify)
                                              }}
                                          >Verify</Button>
                                      </Grid>
                                  }
                                  <Grid item>
                                      <Button variant='contained' style={{
                                          backgroundColor: loading ? '' : '#E35480'
                                      }}  
                                      disabled={loading}
                                      onClick={() => {
                                          setOpenDialog({
                                              open: true,
                                              type: 'reject',
                                              data: value
                                          })
                                      }}><IconX size={15}/></Button> 
                                  </Grid>
                                  {
                                      (status !== 'waiting_list') &&
                                      <Grid item>
                                          <Button variant="contained" 
                                          disabled={loading}
                                          sx={{
                                              backgroundColor: '#FFA500'
                                          }}
                                          onClick={() => {
                                              updateApplicationStatus({
                                                  _id: value._id,
                                                  status: 'waiting_list'
                                              })
                                          }}><IconHourglass size={15}/></Button> 
                                      </Grid>
                                  }
                                  {
                                      (status !== "approve") &&
                                      <Grid item>
                                          {
                                              isFull ?
                                              <Tooltip title={"Full"}>
                                                  <span>
                                                      <Button variant="contained" 
                                                          sx={{
                                                              backgroundColor: '#0198E1'
                                                          }}
                                                          disabled={(!v.verifyId || unverified) || loading || isFull}
                                                          onClick={() => {
                                                              if (!v.verifyId || unverified) { return; }
                                                              setOpenDialog({
                                                                  open: true,
                                                                  type: 'approve',
                                                                  data: v
                                                              })
                                                          }}><IconCheck size={15}/></Button> 
                                                  </span>
                                              </Tooltip>
                                              :
                                              <Button variant="contained" 
                                                  sx={{
                                                      backgroundColor: '#0198E1'
                                                  }}
                                                  disabled={(!v.verifyId || unverified) || loading || isFull}
                                                  onClick={() => {
                                                      if (!v.verifyId || unverified) { return; }
                                                      setOpenDialog({
                                                          open: true,
                                                          type: 'approve',
                                                          data: value
                                                      })
                                                  }}><IconCheck size={15}/></Button> 
                                          }
                                      </Grid>   
                                  }
                              </Grid>
                          </Grid>
                      }
                      </Grid>
                  )
              })
          }
          {
              openDialog.open &&
              <Dialog open={openDialog.open} onClose={() => setOpenDialog(prev => ({
                ...prev,
                type: null,
                data: null,
                open: false }))}>
                  <Card>
                      <Grid sx={{
                          p: 3,
                          minWidth: window.innerWidth < 444 ? '300px' : '360px'
                      }}>
                          <Grid pb={1}>
                              <TCLabel>Are you sure want to {openDialog.type || ''} ?</TCLabel>
                          </Grid>
                          <Grid container pb={1} >
                              <Grid container xs={12} spacing={1} pt={1} justifyContent={"right"}>
                                  <Grid item>
                                      <Button onClick={() => { setOpenDialog(prev => ({
                                      ...prev,
                                      type: null,
                                      data: null,
                                      open: false })) }}>Cancel</Button>
                                  </Grid>
                                  <Grid item>
                                      <Button variant='contained' style={{
                                          backgroundColor: loading ? 'rgba(0, 0, 0, 0.26)' : 
                                          openDialog.type == "approve" ? '#0198E1' : '#E35480'
                                      }} 
                                      disabled={loading}
                                      onClick={() => { 
                                          setLoading(true)
                                          if (openDialog.type == "approve") {
                                              // confirmPayment(adminDiscount)
                                              updateApplicationStatus({
                                                  _id: openDialog.data._id,
                                                  status: 'approve'
                                              })
                                          }
                                          if (openDialog.type == "reject") {
                                              // rejectOrder()
                                              updateApplicationStatus({
                                                  _id: openDialog.data._id,
                                                  status: 'reject'
                                              })
                                          }
                                      }} >{openDialog.type == "approve" ? "Approve" : "Reject"}</Button>
                                  </Grid>
                              </Grid>
                          </Grid>
                      </Grid>
                  </Card>
              </Dialog>
          }
      </Grid>
  )
}

function VerificationForm ({
    userId, reloadAll
}) {
    
    const [ form, setForm ] = useState(null)
    const [ loading, setLoading ] = useState(false)
    const [ openDialog, setOpenDialog ] = useState({
        open: false,
        data: null,
        type: null
    })
    const [ cropperDialog, setCropperDialog ] = useState({
        open: false,
        data: null
    })

    useEffect(() => {
        loadVerification()
    }, [])

    const loadVerification = async () => {
        let { data, error } = await getApplicantVerification(userId)
        if (data) { 
            if (!data._id) { setForm(null); return; }
            setForm({
                ...data,
                gender: data.userId.gender,
                name: data.idName
            })
        }
    }

    const updateVerification = async ({
        _id, reject, verify, name, gender
    }) => {
        let { data, error } = await updateVerificationStatus({
            _id,
            name, gender,
            reject, verify
        })
        await loadVerification();
        if (reloadAll) reloadAll(); 
    }

    const savetoAWS = async ({
        _id, idPhoto
    }) => {
        setCropperDialog({
            open: false,
            image: null,
            data: null
        })
        console.log('here save to AWS', _id, idPhoto)
        setLoading(true)
        let images = await handleUpload(idPhoto)
        await updateVerificationPhoto({
            _id, idPhoto: images[0]
        })
        await loadVerification();
        if (reloadAll) reloadAll(); 
        setLoading(false)
    }

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
    }

    if (!form) return <></>;

    return (
        <Grid p={2} pb={0} xs={12}>
            {
                form._id &&
                <>
                    <TCLabel bold>Player Verification</TCLabel>
                    <Grid mt={0.5}>
                        <TCInput label={"ID Name"} value={form.name} disabled={false} onChange={(e) => { onChange({ name: e.currentTarget.value }) }}/>
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <TCLabel style={{color: "rgb(133, 133, 133)"}}>Gender</TCLabel>
                        <Grid item container mt={-0.5}>
                            <Grid item>
                                <FormControlLabel control={<Checkbox disabled={false} checked={form.gender == "male" ? true : false} onChange={() => {
                                    onChange({gender: "male"})
                                }} />} label={<TCLabel>Male</TCLabel>} />
                            </Grid>
                            <Grid item>
                                <FormControlLabel control={<Checkbox disabled={false} checked={form.gender == "female" ? true : false} onChange={() => {
                                    onChange({gender: "female"})
                                }} />} label={<TCLabel>Female</TCLabel>} /> 
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container alignItems={"end"}>
                        <Grid item mt={-0.5} xs>
                            <TCLabel style={{color: "rgb(133, 133, 133)"}}>Photo</TCLabel>
                            <Badge overlap='circular' anchorOrigin={{ vertical: 'bottom', horizontal: 'right'}}
                                badgeContent={
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setCropperDialog({
                                                open: true,
                                                data: form,
                                                image: form.rawImage || form.idPhoto,
                                            });
                                        }}
                                        style={{
                                            backgroundColor: color.primary,
                                            color: 'white',
                                            borderRadius: 15,
                                            width: 30,
                                            height: 30,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',   // <-- add this
                                            cursor: 'pointer'
                                        }}
                                        >
                                        <IconPencil size={20} stroke={1.5} /> {/* Icon centered + resized */}
                                    </div>
                                }
                            >
                                <img width={'auto'} height={200} style={{borderRadius: 100}} src={form.idPhoto} alt="" />
                            </Badge>
                            
                        </Grid>
                        <Grid item mt={-0.5} container spacing={1} xs sx={{
                            textAlign: 'right',
                            justifyContent: 'right'
                        }}>
                            <Grid item>
                                <Button variant='contained' style={{ backgroundColor: '#E35480' }}
                                    onClick={() => { 
                                        setOpenDialog({
                                            open: true,
                                            type: 'reject'
                                        })
                                    }}
                                >Reject</Button>
                            </Grid>
                            <Grid item>
                                <Button variant='contained'
                                    onClick={() => {
                                        setOpenDialog({
                                            open: true,
                                            type: 'approve'
                                        })
                                    }}
                                >Verify</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            }
            {
                !form._id &&
                <div>No data</div>
            }
            {
                openDialog.open &&
                <Dialog open={openDialog.open} onClose={() => {
                    setOpenDialog(prev => ({
                    ...prev,
                    type: null,
                    data: null,
                    open: false }))
                }}>
                    <Card>
                        <Grid sx={{
                            p: 3,
                            minWidth: window.innerWidth < 444 ? '300px' : '360px'
                        }}>
                            <Grid pb={1}>
                                <TCLabel>Are you sure want to {openDialog.type || ''} ?</TCLabel>
                            </Grid>
                            <Grid container pb={1} >
                                <Grid container xs={12} spacing={1} pt={1} justifyContent={"right"}>
                                    <Grid item>
                                        <Button onClick={() => { setOpenDialog(prev => ({
                                        ...prev,
                                        type: null,
                                        data: null,
                                        open: false })) }}>Cancel</Button>
                                    </Grid>
                                    <Grid item>
                                        <Button variant='contained' style={{
                                            backgroundColor: loading ? 'rgba(0, 0, 0, 0.26)' : 
                                            openDialog.type == "approve" ? '#0198E1' : '#E35480'
                                        }} 
                                        disabled={loading}
                                        onClick={() => { 
                                            setLoading(true)
                                            if (openDialog.type == "approve") {
                                                // confirmPayment(adminDiscount)
                                                updateVerification({
                                                    _id: form._id,
                                                    name: form.name,
                                                    gender: form.gender,
                                                    reject: false, verify: true
                                                })
                                            }
                                            if (openDialog.type == "reject") {
                                                // rejectOrder()
                                                updateVerification({
                                                    _id: form._id,
                                                    reject: true, verify: false
                                                }) 
                                            }
                                        }} >{openDialog.type == "approve" ? "Approve" : "Reject"}</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Card>
                </Dialog>
            }
            {
                cropperDialog.open &&
                <Dialog open={cropperDialog.open} onClose={() => {
                    setCropperDialog({
                        open: false,
                        image: null,
                        data: null
                    })
                }}>
                    <ImageCropper image={
                        `https://images.weserv.nl/?url=${encodeURIComponent(cropperDialog.image)}`
                    } 
                    savetoAWS={(e) => {
                        savetoAWS({
                            _id: cropperDialog.data._id,
                            idPhoto: e
                        })
                    }}
                    setOpenCrop={(e) => {
                        setCropperDialog({
                            open: false,
                            image: null,
                            data: null
                        })
                        // onChange({ idPhoto: [e] })
                    }}/>
                </Dialog>
            }
        </Grid>
    )
}

export default TournamentParticipant;